import React from "react";
import SkeletonText from "./SkeletonText";
import SkeletonButton from "./SkeletonButton";

const SkeletonHeader = ({
  showBackButton = true,
  showTitle = true,
  showSubtitle = true,
  showActions = true,
  className = "",
}) => {
  return (
    <div className={`bg-white shadow-sm border-b ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            {showBackButton && (
              <div className="w-8 h-8 bg-gray-200 rounded animate-pulse" />
            )}
            <div className="space-y-2">
              {showTitle && <SkeletonText size="md" width="48" />}
              {showSubtitle && <SkeletonText size="sm" width="32" />}
            </div>
          </div>
          {showActions && <SkeletonButton size="md" width="24" />}
        </div>
      </div>
    </div>
  );
};

export default SkeletonHeader;
